import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";

import { WMS2060_R01Dto } from "./Dto_WMS2060_R01";
import { WMS2060_R01Filter } from "./Store_WMS2060_R01";

const baseUrl = `${config.apiUrl}/WMS2060_R01`;

export const getWMS2060_R01List = async (option: string, params: Partial<WMS2060_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`
    return await getData<ResponseDto<WMS2060_R01Dto[]>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0
        } as WMS2060_R01Filter
    });
}

export const getWMS2060_R01AllCount = async (params: Partial<WMS2060_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: { 
            ...params
        } as WMS2060_R01Filter
    });
}

export const postWMS2060_R01 = async (data: WMS2060_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<WMS2060_R01Dto[], ResponseDto<WMS2060_R01Dto[]>>(url, data);
}

export const patchWMS2060_R01 = async (data: WMS2060_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<WMS2060_R01Dto[], ResponseDto<WMS2060_R01Dto[]>>(url, data);
}

export const disableWMS2060_R01 = async (data: string[]) => {
    const url = `${baseUrl}/disable`;
    return await patchData<string[], ResponseDto<any>>(url, data);
}

export const deleteWMS2060_R01 = async (orgCd: string) => {
    const url = `${baseUrl}/${orgCd}`;
    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_WMS2060_R01 = async (option: string, params: Partial<WMS2060_R01Filter>, listLength: number = 0) => {
    
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0 
        } as WMS2060_R01Filter
    });
}
export const getPdfBlob_WMS2060_R01 = async (option: string, params: Partial<WMS2060_R01Filter>, listLength: number = 0, documentCompCd: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: {
			...params,
			listLength: listLength ?? 0,
			documentCompCd: documentCompCd
		} as WMS2060_R01Filter,
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};